import { render } from "./capitalFlow.vue?vue&type=template&id=6f04fdef&scoped=true"
import script from "./capitalFlow.vue?vue&type=script&lang=js"
export * from "./capitalFlow.vue?vue&type=script&lang=js"

import "./capitalFlow.vue?vue&type=style&index=0&id=6f04fdef&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f04fdef"]])

export default __exports__